<template>
    <div class="flex flex-col gap-8">
        <date-picker :input-label="$t('general.from')" v-model="filter.date_from"/>
        <date-picker :input-label="$t('general.to')" v-model="filter.date_to"/>
    </div>
</template>

<script>
import DatePicker from '../forms/DatePicker.vue';

export default {
    components: {
        'date-picker': DatePicker
    },
    props: {
        filter: Object
    },
}
</script>
